import React from 'react';
import GenericQRCodeComponent from './generic-qr-code.component';

const GenericQRCode = (props) => {
    return <GenericQRCodeComponent {...props} />;
};

export default GenericQRCode;
